var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SmartTable',_vm._b({staticClass:"table",attrs:{"name":"routine-picker"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('TableRow',_vm._b({scopedSlots:_vm._u([{key:"name",fn:function(ref){
var columnValue = ref.columnValue;
var rowItem = ref.rowItem;
var index = ref.index;
return [_c('span',{staticClass:"fs-13"},[_vm._v(_vm._s(columnValue))])]}},_vm._l((7),function(i){return {key:("journey" + (i-1)),fn:function(ref){
var _obj;

var columnValue = ref.columnValue;
var rowItem = ref.rowItem;
var index = ref.index;return [(columnValue)?_c('span',{staticClass:"jrn fs-13",class:( _obj = {}, _obj[("background-" + ([columnValue.color]))] = true, _obj )},[_vm._v(_vm._s(columnValue.name))]):_vm._e()]}}})],null,true)},'TableRow',slotProps,false))]}}]),model:{value:(_vm.tableData),callback:function ($$v) {_vm.tableData=$$v},expression:"tableData"}},'SmartTable',_vm.table,false))}
var staticRenderFns = []

export { render, staticRenderFns }